module.exports = __webpack_public_path__ + "img/qr.a54dd227.jpg";